const SKIN_COLORS = {
  light: "light",
  medium: "medium",
  dark: "dark",
};

Object.freeze(SKIN_COLORS);

export { SKIN_COLORS };
